import { render, staticRenderFns } from "./StatisticCardVertical.vue?vue&type=template&id=f8243c78&"
import script from "./StatisticCardVertical.vue?vue&type=script&lang=js&"
export * from "./StatisticCardVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports